if (!customElements.get("product-metafield-tabs")) {
  customElements.define(
    "product-metafield-tabs",
    class ProductMetafieldTabs extends HTMLElement {
      constructor() {
        super();
        this.navItems = this.querySelectorAll(".product-tabs__nav-item");
        this.panes = this.querySelectorAll(".product-tabs__pane");
        this.showMoreBtns = this.querySelectorAll(".product-tabs__show-more");

        this.navItems.forEach((item) => {
          item.addEventListener("click", () => {
            const tab = item.getAttribute("data-tab");
            this.switchTab(tab);
          });
        });

        this.showMoreBtns.forEach((btn) => {
          btn.addEventListener("click", () => {
            const pane = btn.closest(".product-tabs__pane");
            const inner = pane.querySelector(".product-tabs__pane-inner");
            const isCollapsed = inner.classList.contains("collapsed");

            if (isCollapsed) {
              inner.classList.remove("collapsed");
              inner.classList.remove("has-fade");
              btn.querySelector(".btn__text").textContent = "Show Less";
              btn.querySelector(".icon-caret-down").classList.add("rotate-180");
            } else {
              inner.classList.add("collapsed");
              inner.classList.add("has-fade");
              btn.querySelector(".btn__text").textContent = "Show More";
              btn
                .querySelector(".icon-caret-down")
                .classList.remove("rotate-180");
            }
          });
        });

        // Initial check for height
        this.init();
      }

      init() {
        this.panes.forEach((pane) => {
          this.checkHeightForPane(pane);
        });
      }

      switchTab(tabId) {
        const clickedNav = Array.from(this.navItems).find(
          (item) => item.getAttribute("data-tab") === tabId
        );
        const isAlreadyActive =
          clickedNav && clickedNav.classList.contains("active");

        if (isAlreadyActive) {
          const activePane = this.querySelector(`#tab-${tabId}`);
          const btn = activePane
            ? activePane.querySelector(".product-tabs__show-more")
            : null;
          if (btn && !btn.classList.contains("hidden")) {
            btn.click();
          }
          return;
        }

        this.navItems.forEach((item) => {
          item.classList.toggle(
            "active",
            item.getAttribute("data-tab") === tabId
          );
        });

        this.panes.forEach((pane) => {
          const isActive = pane.id === `tab-${tabId}`;
          pane.classList.toggle("active", isActive);
          if (isActive) {
            this.checkHeightForPane(pane);
            const btn = pane.querySelector(".product-tabs__show-more");
            if (btn && !btn.classList.contains("hidden")) {
              const inner = pane.querySelector(".product-tabs__pane-inner");
              inner.classList.remove("collapsed");
              inner.classList.remove("has-fade");
              btn.querySelector(".btn__text").textContent = "Show Less";
              btn.querySelector(".icon-caret-down").classList.add("rotate-180");
            }
          }
        });
      }

      checkHeightForPane(pane) {
        const inner = pane.querySelector(".product-tabs__pane-inner");
        const btn = pane.querySelector(".product-tabs__show-more");
        if (!inner || !btn) return;

        // Reset to measure correctly
        inner.classList.remove("collapsed");
        inner.classList.remove("has-fade");

        const fullHeight = inner.scrollHeight;
        const threshold = 120; // 5 lines + buffer for paragraph margins

        if (fullHeight > threshold) {
          btn.classList.remove("hidden");
          inner.classList.add("collapsed");
          inner.classList.add("has-fade");
        } else {
          btn.classList.add("hidden");
          inner.classList.remove("collapsed");
          inner.classList.remove("has-fade");
        }
      }
    }
  );
}
